<spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
<div class="card">
  <div class="card-body">
    <div class="row text-center">
      <div class="col">
        <h5 class="pb-2 mb-2">{{ 'listofdgc.List of District Ganga Committees in the' | translate }} {{ 'tabledataforstates.' + titleCase(state['name']) | translate}} {{ 'header.state' | translate }}</h5>        
      </div>
      <div class="col-auto d-flex justify-content-end">
        <button class="btn btn-info pointer" (click)="printListofDGCs()" type="submit">{{ 'listofdgc.print' | translate }}</button>
      </div>
    </div>

    <div class="table-responsive m-2" id="content">
      <table class="table table-sm w-50" *ngIf="dgcList">
        <thead>
          <tr class="text-center  ">
            <th>{{'trigManage.sno' | translate}}</th>
            <th>{{ 'trigManage.statename' | translate }} </th>
            <th>{{ 'listofdgc.District Ganga Committee Name' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dgc of dgcList; let i = index">
            <td>{{i+1}}</td>
            <td>{{ 'tabledataforstates.' + titleCase(state['name']) | translate }}</td>
            <td>{{ 'districtsdata.' + dgc | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>